import React from 'react';
import { MessageCircle } from 'lucide-react';
import CopyablePhone from './CopyablePhone';

/**
 * ChannelBadge — renders a channel badge with a colored background.
 *
 * Props:
 *   color          {string}  Hex color from database (e.g., '#4CAF50')
 *   channel_name   {string}  Display phone number or custom name (used in tooltip and display)
 *   custom_name    {string}  Optional custom name for the channel
 *   size           {'sm'|'md'|'lg'}  16 / 20 / 28 px  (default: 'sm')
 *   className      {string}  additional Tailwind classes
 */
const SIZES = {
    sm: 16,
    md: 20,
    lg: 28,
};

const ChannelBadge = ({ color, channel_name, custom_name, size = 'sm', className = '', showPhoneActions = true }) => {
    const px = SIZES[size] || SIZES.sm;
    const iconSize = Math.max(10, px * 0.6);
    
    const tooltipText = custom_name 
        ? `${custom_name} (${channel_name})`
        : (channel_name || 'Canal desconocido');

    return (
        <span className="inline-flex items-center gap-1">
            <span
                title={tooltipText}
                className={color
                    ? `inline-flex items-center justify-center rounded shrink-0 ${className}`
                    : `inline-flex items-center justify-center rounded border border-slate-600 bg-slate-800 text-slate-400 font-bold select-none ${className}`
                }
                style={color
                    ? { width: px, height: px, backgroundColor: color, color: 'white' }
                    : { width: px, height: px, fontSize: Math.max(8, px * 0.5) }
                }
            >
                {color ? <MessageCircle size={iconSize} strokeWidth={2} /> : '?'}
            </span>
            {showPhoneActions && channel_name && (
                <CopyablePhone phone={channel_name} showText={false} />
            )}
        </span>
    );
};

export default ChannelBadge;
